export enum AuditTrailTableAccessor {
  Amount = 'amount',
  Balance = 'balance',
  Date = 'date',
  Description = 'description',
  NetAmount = 'netAmount',
  Rate = 'rate',
  Transaction = 'transaction',
  Voucher = 'voucher',
}
